import type { PositionCategory } from 'store/admins/types';

export const adminTypes = {
  admin: ['Admin Information'],
};

export const PositionCategoryOptions: { label: string; value: PositionCategory }[] = [
  { label: 'Campaign Manager', value: 'CAMPAIGN_MANAGER' },
  { label: 'Compliance', value: 'COMPLIANCE' },
  { label: 'Other', value: 'OTHER' },
];

export const subscriptionLevelOptions = [
  { label: 'Basic', value: 'BASIC' },
  { label: 'Premium', value: 'PREMIUM' },
];

export const roleTypeOptions = [
  { label: 'Super Admin', value: 'super_admin' },
  { label: 'Recipient Admin', value: 'recipient_admin' },
  { label: 'Partner Admin', value: 'partner_admin' },
];
